export default __webpack_public_path__ + "static/media/about.1075b6d0.jpg";